/**
 * ネットワークIDのバリデーション.
 * 先頭は半角小文字「net-」で、以降は半角英数字8文字で入力されること
 */

export default {
  validate(value: string | undefined | null): boolean {
    if (!value) return true;

    const pattern = /^net-[0-9A-Za-z]{8}$/;

    return pattern.test(value);
  },
};
